export default __webpack_public_path__ + "static/13884-1fe5b67234a820e7d81c26a9004b3bb0.jpg";